import { ENTITY_API_URL } from "../environment";
import { initAxiosFor } from "../security/axiosUtils";

export function useSiteService() {
  const axiosInstance = initAxiosFor(ENTITY_API_URL);
  return {
    getAll: async (includeDeleted: boolean = false) => (await axiosInstance.get(`/api/sites?includeDeleted=${includeDeleted}`))?.data,
    getOne: async (id: string) => (await axiosInstance.get(`/api/sites/` + id))?.data,
    post: async (value: any) => (await axiosInstance.post(`/api/sites`, value))?.data,
    put: async (id: string, value: any) => (await axiosInstance.put(`/api/sites/` + id, value))?.data,
    postCommand: async (id: string, command: any) => (await axiosInstance.post(`/api/sites/${id}/commands`, command))?.data,
  }
}